import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

const initialState = {
  phoneNumber: '',
  token: '',
  otpHash: '',
  userData: '',
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setNumber: (state, action) => {
      state.phoneNumber = action.payload;
      // localStorage.setItem('phoneNumber', state.phoneNumber);
      Cookies.set('phoneNumber', state.phoneNumber, {
        expires: 604800 * (10 ^ 3),
        sameSite: 'strict',
        secure: true,
      });
    },
    setToken: (state, action) => {
      state.token = action.payload;
      // localStorage.setItem('token', action.payload); //save access token in local storage
      Cookies.set('token', action.payload, {
        expires: 604800 * (10 ^ 3),
        sameSite: 'strict',
        secure: true,
      });
    },
    setOtpHash: (state, action) => {
      state.otpHash = action.payload;
    },
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
  },
});

export const { setNumber, setToken, setOtpHash, setUserData } =
  authSlice.actions;

export default authSlice.reducer;
